import { verifyAuthApi } from "@/features/auth/services/verify.api";

/**
 *  Application layer
 *  Responsible for transforming data from the interface layer into data required by the backend
 */

export const verifyAuth = async (token: string | null): Promise<void> => {
  // Only response 200 or 401, no other response
  await verifyAuthApi(token);
};
